// agentApi.js
import { marked } from 'marked';
import _ from 'lodash';

export async function fetchAgentTemplate({baseUrl, advertiserUrl, selectedConnectionType, originalTemplate }) {  
  try {
    const scrapedHtml = await fetch(`${baseUrl}/crawl_advertiser`, {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ advertiser_url: advertiserUrl, web_source_type: selectedConnectionType}),
    });
    const tempRes = await scrapedHtml.json();
      const response = await fetch(`${baseUrl}/invoke`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        advertiser_url: advertiserUrl,
        web_source_type: selectedConnectionType,
        scraped_html: _.get(tempRes, 'data.scraped_html', null)
              ? tempRes.data.scraped_html
              : null

      }),
        });
    if (!scrapedHtml.ok) {
      throw new Error('Failed to scrape advertiser website');
    }
    if (!response.ok) {
      throw new Error('Failed to fetch agent template');
    }

    const data = await response.json();
    const rawContent = data.message[0].content;
    const htmlContent = marked(rawContent);
 
    const textareaCloseTag = '</textarea>';
    const index = originalTemplate.indexOf(textareaCloseTag);
    if (index === -1) throw new Error('Not found </textarea>');
 
    const updatedTemplate =
      originalTemplate.slice(0, index + textareaCloseTag.length) +
      `<div id="agent-content">${htmlContent}</div>`;
 
    return {
      updatedTemplate,
      agentContent: htmlContent,
      rawContent
    };
  } catch (error) {
    console.error('API call failed:', error);
    throw error;
  }
}
